import TrackingStatus from '../../../../../components/units/Management/AiAgent/Common/Tracking';

export default function AiAgentManualUploadStatus() {
  return <TrackingStatus trackingType="manual" />;
}
